module.exports = __webpack_public_path__ + "img/no-data-spex.785bbbf9.png";